import MentoringsSearch from './container';

export default MentoringsSearch;
